import { PendingApprovalPage } from "../../modules/pending-approval"
 
interface PendingApprovalsProps {
  sidebarOpen?: boolean
}

export default function PendingApprovals({ sidebarOpen }: PendingApprovalsProps) {
  return <PendingApprovalPage />
}
